import apiClient from '../../../../core/Api';
import { TagType, TagRequestParams } from '../../../../data/types/tags.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class LocationService {
  static create = async (reqParams: TagRequestParams): Promise<TagType> =>
    apiClient.post(`${API_BASE_URL}/locations`, reqParams).then((response) => response.data);

  static get = async (): Promise<TagType[]> =>
    apiClient.get(`${API_BASE_URL}/locations`).then((response) => {
      const { data } = response;
      return data.rows;
    });

  static deleteLocations = async (ids: number[]): Promise<boolean> => {
    const response = await apiClient.delete(`${API_BASE_URL}/locations/${ids}`);
    return response.status === 204;
  };
}

export default LocationService;
